/* ============================================================
   Utilidades compartidas para los dashboards de telefonía.
   Normalización de respuestas (RespuestaGenerica + Lambicom),
   extracción de listas y formateadores.
   ============================================================ */

export const PROVEEDOR = 4;

/* Paleta corporativa para gráficas */
export const PALETA = [
  "#4f46e5",
  "#06b6d4",
  "#10b981",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#ec4899",
  "#0ea5e9",
];

/* ---------- Formateadores ---------- */
export const fmtNumero = (n) =>
  n === null || n === undefined || isNaN(n) ? "0" : Number(n).toLocaleString("es-MX");

export const fmtDuracion = (segundos) => {
  const s = Math.round(Number(segundos) || 0);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const seg = s % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${seg}s`;
  return `${seg}s`;
};

export const fmtPorcentaje = (n) =>
  n === null || n === undefined || isNaN(n) ? "0%" : `${Number(n).toFixed(1)}%`;

export const fmtGB = (bytes) =>
  bytes ? (Number(bytes) / 1073741824).toFixed(2) + " GB" : "0 GB";

/* ---------- Fechas ---------- */
export const aFechaDesde = (fecha) => (fecha ? `${fecha} 00:00:00` : "");
export const aFechaHasta = (fecha) => (fecha ? `${fecha} 23:59:59` : "");

export const hoyISO = () => new Date().toISOString().slice(0, 10);
export const haceDiasISO = (dias) => {
  const d = new Date();
  d.setDate(d.getDate() - dias);
  return d.toISOString().slice(0, 10);
};

/**
 * Normaliza la respuesta del backend.
 * - Desenvuelve RespuestaGenerica { status, message, data }.
 * - `data` puede venir como string JSON.
 * - Lambicom envuelve en claves contenedoras: { data: {...} } o { stats: {...} }.
 * Devuelve el objeto/array útil de Lambicom.
 */
export const normalizar = (res) => {
  let payload = res;
  if (payload && payload.data !== undefined) payload = payload.data;
  if (typeof payload === "string") {
    try {
      payload = JSON.parse(payload);
    } catch (e) {
      return null;
    }
  }
  if (payload && typeof payload === "object") {
    if (payload.stats !== undefined && typeof payload.stats === "object" && payload.stats !== null) {
      return payload.stats;
    }
    if (
      payload.data !== undefined &&
      (Array.isArray(payload.data) || typeof payload.data === "object")
    ) {
      payload = payload.data;
    }
  }
  return payload;
};

/**
 * Extrae un array de un payload ya normalizado. Busca en claves comunes
 * (extensions, hourly, channels, servers, alerts, items, data...).
 */
export const extraerLista = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];
  const claves = [
    "extensions",
    "hourly",
    "hourly_distribution",
    "hours",
    "channels",
    "servers",
    "alerts",
    "conferences",
    "top_agents",
    "by_queue",
    "items",
    "results",
    "data",
    "rows",
    "list",
  ];
  for (const k of claves) {
    if (Array.isArray(payload[k])) return payload[k];
  }
  return [];
};

/**
 * Lee el primer campo definido de un objeto entre varias claves alternativas.
 * Útil para tolerar las diferencias entre la respuesta real y la documentada
 * (ej: avg_duration vs avg_duration_seconds, missed_calls vs unanswered_calls).
 */
export const pick = (obj, ...claves) => {
  if (!obj) return undefined;
  for (const k of claves) {
    if (obj[k] !== undefined && obj[k] !== null) return obj[k];
  }
  return undefined;
};
